import { createResourceService, deleteResourceService, resourcesService } from '@http/resourcesService'
import { PayloadAction } from '@reduxjs/toolkit'
import { Resource } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  createResource,
  createResourceSuccess,
  deleteResource,
  deleteResourceSucces,
  getResources,
  resourceFailed,
  resourceSuccess
} from './resourcesSlice'

export function* resourceHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const resources: Resource[] = yield call(resourcesService, cocap)
    yield put(resourceSuccess(resources))
  } catch (e) {
    yield put(resourceFailed(e.message))
  }
}

export function* createResourceHttp(action: PayloadAction<Resource>) {
  const { cocap } = yield select(selectCredentials)
  try {
    const response: Resource = yield call(createResourceService, cocap, action.payload)
    yield put(createResourceSuccess(response))
  } catch (e) {
    yield put(resourceFailed(e.message))
  }
}

export function* deleteResourceHttp(action: PayloadAction<string>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(deleteResourceService, action.payload, cocap)
    yield put(deleteResourceSucces(action.payload))
  } catch (e) {
    yield put(resourceFailed(e.message))
  }
}

export default function* resourceSaga() {
  yield takeEvery(getResources.type, resourceHttp)
  yield takeEvery(createResource.type, createResourceHttp)
  yield takeEvery(deleteResource.type, deleteResourceHttp)
}
